module.exports = __webpack_public_path__ + "img/ico-file.eb8738ba.svg";